/**
 * Icon component for SVG sprite sheet icons
 * Renders SVG icons using sprite sheet references with customizable styling
 */

import clsx from 'clsx'
import { ComponentProps } from 'preact'

function Icon({ id, className, ...props }: ComponentProps<'svg'>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" className={clsx('icon', className)} fill="none" { ...props} >
      <use href={`#${id}`} x="0" y="0" />
    </svg>
  )
}

export default Icon
